import React, { useEffect, useMemo, useRef } from 'react';
import { BaseButton, IconButton, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { XIcon } from '@fronton/icons-react';
import { cx } from 'linaria';
import { analyticsUtils } from 'utils';
import { StoreItemProps } from './types';
import { StoreInfo } from '../store-info';
import { styles } from './style';

export const StoreItem: React.FC<StoreItemProps> = React.memo(
  ({ active, setActive, scrollCb, ...props }) => {
    const { id, name } = props;
    const ref = useRef<null | HTMLDivElement>(null);
    const { t } = useTranslation();
    const wrapperClass = useMemo(() => cx(styles.storeItem, active && styles.activeStore), [active]);
    const buttonClass = useMemo(() => cx(styles.storeButton, active && styles.activeButton), [active]);

    const openInfo = () => {
      setActive(props);
      analyticsUtils.sendEvent('GA:clickButton', {
        elementType: 'button', // const
        elementBlock: 'shopPage', // const
        elementText: name, // название магазина
        elementName: 'list', // const название блока
      });
    };

    const closeInfo = () => {
      setActive(null);
    };

    useEffect(() => {
      if (active) {
        scrollCb(ref);
      }
    }, [active, scrollCb]);

    return (
      <div
        ref={ref}
        className={wrapperClass}
        key={id}
        role="listitem"
        data-qa="stores-list-item"
        itemScope
        itemType="http://schema.org/Organization"
      >
        <div className={styles.itemHeader}>
          <BaseButton className={buttonClass} onClick={openInfo}>
            <Typography
              color="text-primary"
              title={name}
              data-qa="store-item-title"
              variant="h3"
              as="div"
              className={styles.storeItemTitle}
              itemProp="name"
            >
              {name}
            </Typography>
          </BaseButton>
          {active && (
            <IconButton
              className={styles.closeButton}
              variant="primary"
              size="l"
              aria-label={t('ui.close')}
              data-qa="store-item-close-button"
              onClick={closeInfo}
              itemProp="name"
            >
              <XIcon type="outline" size="l" color="control-primary" />
            </IconButton>
          )}
        </div>

        <StoreInfo active={active} {...props} />
      </div>
    );
  },
);
